import { ReactionUser } from "@/server/types/umbra/reaction";

import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { isUserAuthenticated } from "@/middleware/auth";

import { umbra_removeReactionFromMessage } from "@/middleware/umbra_reactions";
import { toast } from "@/hooks/useToast";
import UserAvatar from "@/components/shared/UserAvatar";

type Props = ReactionUser & {
  chatId: string;
  messageId: string;
};

export default function ReactionListItem({
  chatId,
  messageId,
  userId,
  reaction,
}: Props) {
  const userFingerPrint = isUserAuthenticated();
  const { t } = useTranslation();

  const isUser = userFingerPrint?.username === userId;

  const handleRemoveReaction = async () => {
    try {
      await umbra_removeReactionFromMessage({
        chatId,
        messageId,
        emoji: reaction,
      });
    } catch (error) {
      toast({
        duration: 1000,
        description:
          error instanceof Error ? error.message : t("errorOccurred"),
        variant: "destructive",
      });
    }
  };

  return (
    <div
      className={cn(
        "flex items-center justify-start gap-3 rounded-md px-4 py-2 align-middle",
        isUser ? "lg:cursor-pointer lg:hover:bg-foreground/5" : "",
      )}
      onClick={isUser ? handleRemoveReaction : undefined}
    >
      <UserAvatar username={userId} className="size-8" />

      <div className="w-full flex-col leading-tight">
        <div> {userId}</div>
        {isUser && (
          <div className="text-xs text-secondary/80">Tap to remove</div>
        )}
      </div>
      <div className="size-5 shrink-0"> {reaction}</div>
    </div>
  );
}
